import { render, staticRenderFns } from "./template_adm.vue?vue&type=template&id=20d5bac1&scoped=true&"
import script from "./template_adm.vue?vue&type=script&lang=js&"
export * from "./template_adm.vue?vue&type=script&lang=js&"
import style0 from "./template_adm.vue?vue&type=style&index=0&id=20d5bac1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d5bac1",
  null
  
)

export default component.exports